var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 386,
    viewBox: "-65 9 406 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man / Head / 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M216.68 383.516L214.974 324.912C214.974 324.912 286.57 330.582 301.884 322.669C301.884 322.669 320.603 226.74 298.277 173.617L297.825 171.549L146.741 153.968L139.877 242.461C134.788 227.531 91.1787 208.342 80.1998 229.725C56.4062 276.056 141.481 307.253 141.481 307.253L132.842 384.221",
    fill: "#CE3D29"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    opacity: 0.403344,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.974 324.911L166.696 314.615L214.743 346.898L214.974 324.911Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.797 229.143L271.479 269.712L251.486 269.965L254.797 229.143Z",
    fill: "#405FD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.776 240.671C236.77 246.135 233.122 251.364 227.631 252.351C222.137 253.34 216.88 249.713 215.887 244.25C214.893 238.787 218.541 233.559 224.032 232.57C229.526 231.581 234.783 235.208 235.776 240.671Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.246 240.671C289.24 246.135 285.592 251.364 280.101 252.351C274.608 253.34 269.35 249.713 268.358 244.25C267.363 238.787 271.012 233.559 276.503 232.57C281.996 231.581 287.254 235.208 288.246 240.671Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M154.228 264.274C153.95 263.594 153.64 262.89 153.298 262.162C141.764 237.613 123.872 227.298 112.121 223.017C105.699 213.568 100.636 203 98.955 191.871C93.6253 156.656 102.944 124.471 123.736 115.247C144.782 105.909 194.633 110.59 250.61 110.59C317.82 110.59 321.522 104.001 321.522 104.001C321.522 104.001 380.768 187.145 271.385 184.728C214.065 183.461 181.447 184.89 181.447 184.89L154.228 264.274Z",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.905 295.811C241.905 295.811 252.198 304.211 264.975 298.828L241.905 295.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M241.905 295.811C241.905 295.811 252.198 304.211 264.975 298.828",
    stroke: "#252535",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.528 287.046C224.528 287.046 230.094 272.573 256.459 273.658C282.824 274.741 286.094 292.675 286.094 292.675L224.528 287.046Z",
    fill: "#19141E"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.4d6087c0.svg";
export { ForwardRef as ReactComponent };